<template>
  <div class="about">
    <div class="name">Education</div>
    <br />
    <div class="role">
      Bachelor's Degree in Electrical Engineering and Communications 
    </div>
    <div class="md-text">
      Sripatum University | 2004
    </div>
    <br />
    <div class="role">
      High School Education 
    </div>
    <div class="md-text">
      Prachuab Witthayalai School | 2000
    </div>
    <br />
    <div class="edu-img">
      <img src="../images/edu1.jpg" />
      <img src="../images/edu2.jpg" />
      <img src="../images/edu3.jpg" />
      <img src="../images/edu4.jpg" />
      <img src="../images/edu5.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {},
  created() {},
  components: {},
};
</script>

